/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './errors';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "cash": {
        "nested": {
          "api": {
            "nested": {
              "InternalRegion": {
                "values": {
                  "CASH_US_WEST_2": 1
                }
              },
              "RequestMetadata": {
                "fields": {
                  "signedClientSession": {
                    "type": "bytes",
                    "id": 1,
                    "rule": "optional"
                  },
                  "region": {
                    "type": "squareup.cash.api.InternalRegion",
                    "id": 2,
                    "rule": "optional"
                  },
                  "deadline": {
                    "type": "uint32",
                    "id": 3,
                    "rule": "optional"
                  },
                  "originIp": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "isRetry": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "ResponseMetadata": {
                "fields": {
                  "errors": {
                    "type": "squareup.cash.api.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "upsertResult": {
                    "type": "squareup.cash.api.ResponseMetadata.UpsertResult",
                    "id": 2
                  }
                },
                "nested": {
                  "UpsertResult": {
                    "values": {
                      "UPSERT_CREATE": 1,
                      "UPSERT_UPDATE": 2
                    }
                  },
                  "result": {
                    "oneof": ["upsertResult"]
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.cash?.nested?.api?.nested?.InternalRegion && !$root.nested?.squareup?.nested?.cash?.nested?.api?.nested?.RequestMetadata && !$root.nested?.squareup?.nested?.cash?.nested?.api?.nested?.ResponseMetadata && !$root.nested?.squareup?.nested?.cash?.nested?.api?.nested?.ResponseMetadata?.nested?.UpsertResult) {
  $root.addJSON(jsonData);
}

/**
 * A list of regions supported by the Cash App Pay API internally, where data is
 * actually stored. Liaison's geo-mesh will convert external regions into internal
 * regions.
 *
 * SOURCE InternalRegion @ squareup/cash/api/contract.proto at 13:1
 */
export const InternalRegion = $root.lookupEnum('squareup.cash.api.InternalRegion').values;
/**
 * Standard metadata for response payloads in the Cash App Pay APIs. All services
 * that are called by Liaison must provide this field in the request payload of their
 * RPC calls.
 *
 * Used by Liaison to propagate API client details to upstream services.
 *
 * SOURCE RequestMetadata @ squareup/cash/api/contract.proto at 27:1
 */
export const RequestMetadata = $root.lookupType('squareup.cash.api.RequestMetadata');
fixType(RequestMetadata);
Builder.createAndAttachToType(RequestMetadata);
/**
 * Standard metadata for response payloads in the Cash App Pay APIs.
 * Used by Liaison to propagate errors and other metadata to API clients.
 *
 * SOURCE ResponseMetadata @ squareup/cash/api/contract.proto at 62:1
 */
export const ResponseMetadata = $root.lookupType('squareup.cash.api.ResponseMetadata');
fixType(ResponseMetadata);
Builder.createAndAttachToType(ResponseMetadata);
/**
 * Possible results for upsert responses.
 *
 * SOURCE UpsertResult @ squareup/cash/api/contract.proto at 79:3
 */
ResponseMetadata.UpsertResult = $root.lookupEnum('squareup.cash.api.ResponseMetadata.UpsertResult').values;